import { STATUSES as BOOKING_CANDIDATE_STATUSES } from "@/constants/booking_candidate"
import { LEVELS as QUESTIONNAIRE_ANSWER_LEVELS } from "@/constants/questionnaire_answer"
import { BOOKING_PURPOSES } from "@/constants/booking"

// deprecated
const getReportOutcomesDeprecated = (booking) => {
  const incompleteOutcome = booking.booking_candidates
    .filter(
      (candidate) =>
        candidate.status !== BOOKING_CANDIDATE_STATUSES.STATUS_COMPLETED.key
    )
    .map((candidate) => candidate.object_id)

  const highRiskOutcome = booking.booking_candidates
    .filter(
      (candidate) =>
        candidate.questionnaire_answer?.recommendation?.warning_level > 3
    )
    .map((candidate) => candidate.object_id)

  const moderateOutcome = booking.booking_candidates
    .filter(
      (candidate) =>
        candidate.questionnaire_answer?.recommendation?.warning_level == 3
    )
    .map((candidate) => candidate.object_id)

  const lowRiskOutcome = booking.booking_candidates
    .filter(
      (candidate) =>
        candidate.questionnaire_answer?.recommendation?.warning_level < 3
    )
    .map((candidate) => candidate.object_id)

  return [
    {
      label: "High Risk",
      chart_label: "High risk outcomes",
      booking_candidate_oids: highRiskOutcome,
      percentage:
        ((highRiskOutcome.length / booking.booking_candidates.length) | 0) *
        100,
      chart_color: "#E14749",
      color: "#E14749",
      dark: true,
      value: "high_risk",
    },
    {
      label: "Moderate",
      chart_label: "Moderate outcomes",
      booking_candidate_oids: moderateOutcome,
      percentage:
        ((moderateOutcome.length / booking.booking_candidates.length) | 0) *
        100,
      chart_color: "#f4a261",
      color: "#f4a261",
      dark: true,
      value: "moderate",
    },
    {
      label: "Low Risk",
      chart_label: "Low risk outcomes",
      booking_candidate_oids: lowRiskOutcome,
      percentage:
        ((lowRiskOutcome.lenght / booking.booking_candidates.length) | 0) * 100,
      chart_color: "#2A9D8F",
      color: "#2A9D8F",
      dark: true,
      value: "low_risk",
    },
    {
      label: "Incomplete",
      chart_label: "Incomplete outcomes",
      booking_candidate_oids: incompleteOutcome,
      percentage:
        ((incompleteOutcome.length / booking.booking_candidates.length) | 0) *
        100,
      chart_color: "#dddddd",
      color: "#dddddd",
      dark: false,
      value: "incomplete",
    },
  ]
}

export type reportOutcome = {
  label: string;
  chart_label: string;
  booking_candidate_oids: string[];
  percentage: number;
  chart_color: string;
  color: string;
  dark: boolean;
  value?: string | null;
}

export const getReportRTWOutcomes = (booking): reportOutcome[] => {
  const isReturnToWork =
    booking.purpose === BOOKING_PURPOSES.PURPOSE_RETURN_TO_WORK.key
  if (!isReturnToWork) {
    return getReportOutcomesDeprecated(booking)
  }

  const incompleteOutcome = booking.booking_candidates
    .filter(
      (candidate) =>
        candidate.status !== BOOKING_CANDIDATE_STATUSES.STATUS_COMPLETED.key
    )
    .map((candidate) => candidate.object_id)

  const completeOutcome = booking.booking_candidates
    .filter(
      (candidate) =>
        candidate.status === BOOKING_CANDIDATE_STATUSES.STATUS_COMPLETED.key
    )
    .map((candidate) => candidate.object_id)
    
  return [
    {
      label: "Complete",
      chart_label: "Complete Outcomes",
      booking_candidate_oids: completeOutcome,
      percentage:
        ((completeOutcome.length / booking.booking_candidates.length) | 0) *
        100,
      chart_color: "#2A9D8F",
      color: "#2A9D8F",
      dark: true,
      value: "complete",
    },
    {
      label: "Incomplete",
      chart_label: "Incomplete Outcomes",
      booking_candidate_oids: incompleteOutcome,
      percentage:
        ((incompleteOutcome.length / booking.booking_candidates.length) | 0) *
        100,
      chart_color: "#dddddd",
      color: "#dddddd",
      dark: false,
      value: "incomplete",
    },
  ]
}

export const getPreEmploymentOutcomes = (booking): reportOutcome[] => {
  const isPreEmployment =
    booking.purpose === BOOKING_PURPOSES.PURPOSE_PRE_EMPLOYMENT.key

  if (!isPreEmployment) {
    return getReportOutcomesDeprecated(booking)
  }

  const incompleteOutcome = booking.booking_candidates
    .filter(
      (candidate) =>
        candidate.status !== BOOKING_CANDIDATE_STATUSES.STATUS_COMPLETED.key
    )
    .map((candidate) => candidate.object_id)

  const highRiskOutcome = booking.booking_candidates
    .filter(
      (candidate) =>
        candidate.questionnaire_answer?.recommendation?.level ===
          QUESTIONNAIRE_ANSWER_LEVELS.LEVEL_NOT_SUITABLE.value
    )
    .map((candidate) => candidate.object_id)

  const moderateOutcome = booking.booking_candidates
    .filter(
      (candidate) =>
        candidate.questionnaire_answer?.recommendation?.level ===
          QUESTIONNAIRE_ANSWER_LEVELS.LEVEL_FURTHER_REVIEW.value
    )
    .map((candidate) => candidate.object_id)

  const lowRiskOutcome = booking.booking_candidates
    .filter(
      (candidate) =>
        candidate.questionnaire_answer?.recommendation?.level ===
          QUESTIONNAIRE_ANSWER_LEVELS.LEVEL_SUITABLE.value
    )
    .map((candidate) => candidate.object_id)

  return [
    {
      label: QUESTIONNAIRE_ANSWER_LEVELS.LEVEL_NOT_SUITABLE.text,
      chart_label:
        QUESTIONNAIRE_ANSWER_LEVELS.LEVEL_NOT_SUITABLE.text + " Outcomes",
      booking_candidate_oids: highRiskOutcome,
      percentage:
        ((highRiskOutcome.length / booking.booking_candidates.length) | 0) *
        100,
      chart_color: "#E14749",
      color: "#E14749",
      dark: true,
      value: "high_risk",
    },
    {
      label: QUESTIONNAIRE_ANSWER_LEVELS.LEVEL_FURTHER_REVIEW.text,
      chart_label:
        QUESTIONNAIRE_ANSWER_LEVELS.LEVEL_FURTHER_REVIEW.text + " Outcomes",
      booking_candidate_oids: moderateOutcome,
      percentage:
        ((moderateOutcome.length / booking.booking_candidates.length) | 0) *
        100,
      chart_color: "#f4a261",
      color: "#f4a261",
      dark: true,
      value: "moderate",
    },
    {
      label: QUESTIONNAIRE_ANSWER_LEVELS.LEVEL_SUITABLE.text,
      chart_label:
        QUESTIONNAIRE_ANSWER_LEVELS.LEVEL_SUITABLE.text + " Outcomes",
      booking_candidate_oids: lowRiskOutcome,
      percentage:
        ((lowRiskOutcome.lenght / booking.booking_candidates.length) | 0) * 100,
      chart_color: "#2A9D8F",
      color: "#2A9D8F",
      dark: true,
      value: "low_risk",
    },
    {
      label: "Incomplete",
      chart_label: "Incomplete Outcomes",
      booking_candidate_oids: incompleteOutcome,
      percentage:
        ((incompleteOutcome.length / booking.booking_candidates.length) | 0) *
        100,
      chart_color: "#dddddd",
      color: "#dddddd",
      dark: false,
      value: "incomplete",
    },
  ]
}

export const getHealthCheckOutcomes = (booking): reportOutcome[] => {
  const isHealthCheck =
    booking.purpose ===
    BOOKING_PURPOSES.PURPOSE_HEALTH_CHECK_FOR_CURRENT_EMPLOYEE.key

  if (!isHealthCheck) {
    return getReportOutcomesDeprecated(booking)
  }

  const incompleteOutcome = booking.booking_candidates
    .filter(
      (candidate) =>
        candidate.status !== BOOKING_CANDIDATE_STATUSES.STATUS_COMPLETED.key
    )
    .map((candidate) => candidate.object_id)

  const completeOutcome = booking.booking_candidates
    .filter(
      (candidate) =>
        candidate.status === BOOKING_CANDIDATE_STATUSES.STATUS_COMPLETED.key
    )
    .map((candidate) => candidate.object_id)

  return [
    {
      label: "Complete",
      chart_label: "Complete Outcomes",
      booking_candidate_oids: completeOutcome,
      percentage:
        ((completeOutcome.length / booking.booking_candidates.length) | 0) *
        100,
      chart_color: "#2A9D8F",
      color: "#2A9D8F",
      dark: true,
      value: "complete",
    },
    {
      label: "Incomplete",
      chart_label: "Incomplete Outcomes",
      booking_candidate_oids: incompleteOutcome,
      percentage:
        ((incompleteOutcome.length / booking.booking_candidates.length) | 0) *
        100,
      chart_color: "#dddddd",
      color: "#dddddd",
      dark: false,
      value: "incomplete",
    },
  ]
}

export const getReportOutcomes = (booking): reportOutcome[] => {
  if (!booking.purpose) {
    return getReportOutcomesDeprecated(booking)
  }
  switch (booking.purpose) {
    case BOOKING_PURPOSES.PURPOSE_PRE_EMPLOYMENT.key:
      return getPreEmploymentOutcomes(booking)
      break
    case BOOKING_PURPOSES.PURPOSE_HEALTH_CHECK_FOR_CURRENT_EMPLOYEE.key:
      return getHealthCheckOutcomes(booking)
      break
    case BOOKING_PURPOSES.PURPOSE_RETURN_TO_WORK.key:
      return getReportRTWOutcomes(booking)
      break
    default:
      return getReportOutcomesDeprecated(booking)
      break
  }
}
